{
    "StatvaluestypeLabel": "Ausgabe für Prozent-, Datums-\/Uhrzeit- und Dauerfelder:",
    "StatvaluestypeBothOptionLabel": "[Zwei Werte (formatiert + roh)]",
    "StatvaluestypeMainOptionLabel": "Nur formatierter Anzeigewert (Text)",
    "StatvaluestypeAlternateOptionLabel": "Nur Rohwert (für die grafische Darstellung + Formelverwendung)",
    "CSVExportFormat_SectionHeader": "CSV\/XLS-Exportformat",
    "CSVExportFormat_SectionPara": "Sie können einstellen, wie Prozent-, Datums-\/Zeit- und Dauer-Statistikwerte in CSV- und XLS-exportierten Berichten generiert werden.",
    "NAME": "CSVExportFormat"
}